// import React, { useEffect, useState } from "react";
// import { Navigate, useLocation } from "react-router-dom";
// import {  getCurrentUser } from "./auth";

// const ProtectedRoute = ({ children, requiredPermission }) => {
//   const [authState, setAuthState] = useState({
//     checked: false,
//     isAuthenticated: false,
//     user: null,
//     permissions: [],
//     roles: []
//   });
//   const location = useLocation();

//   useEffect(() => {
//     let isMounted = true;

//     const checkAuth = async () => {
//       try {
//         const user = await getCurrentUser();
//         const isAuth = user !== null;

//         if (isMounted) {
//           setAuthState({
//             checked: true,
//             isAuthenticated: isAuth,
//             user: user,
//             permissions: user?.permissions || [],
//             roles: user?.roles || []
//           });
//         }
//       } catch (error) {
//         if (isMounted) {
//           setAuthState({
//             checked: true,
//             isAuthenticated: false,
//             user: null,
//             permissions: [],
//             roles: []
//           });
//         }
//       }
//     };

//     checkAuth();

//     return () => {
//       isMounted = false;
//     };
//   }, [location.pathname]);

//    if (!authState.checked) {
//     return (
//       <div className="flex justify-center items-center h-screen">
//         <div className="w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
//       </div>
//     );
//   }

//   if (!authState.isAuthenticated) {
//     if (location.pathname !== "/login") {
//       return <Navigate to="/login" replace state={{ from: location }} />;
//     }
//     return null;
//   }

//   if (requiredPermission && !authState.permissions.includes(requiredPermission)) {
//     return <Navigate to="/unauthorized" replace />;
//   }

//   return children;
// };

// export default ProtectedRoute;

// import React, { useEffect, useState } from "react";
// import { Navigate, useLocation } from "react-router-dom";
// import { getCurrentUser, clearAuthData } from "./auth";

// const ProtectedRoute = ({ children, requiredPermission }) => {
//   const [authState, setAuthState] = useState({
//     checked: false,
//     isAuthenticated: false,
//     user: null,
//     permissions: [],
//     roles: [],
//   });
//   const location = useLocation();

//   useEffect(() => {
//     let isMounted = true;
//     let retryCount = 0;
//     const maxRetries = 1;

//     const checkAuth = async (attempt = 0) => {
//       try {
//         const user = await getCurrentUser(attempt > 0);
//         if (!user && attempt < maxRetries) {
//           // Try refreshing token once
//           return await checkAuth(attempt + 1);
//         }

//         if (isMounted) {
//           setAuthState({
//             checked: true,
//             isAuthenticated: !!user,
//             user: user,
//             permissions: user?.permissions || [],
//             roles: user?.roles || [],
//           });
//         }
//       } catch (error) {
//         if (isMounted) {
//           setAuthState({
//             checked: true,
//             isAuthenticated: false,
//             user: null,
//             permissions: [],
//             roles: [],
//           });
//         }
//       }
//     };

//     // Only check auth if:
//     // 1. We haven't checked yet, or
//     // 2. The pathname changed and it's not a protected route we're coming from
//     if (
//       !authState.checked ||
//       (location.pathname !== "/login" && location.pathname !== "/unauthorized")
//     ) {
//       checkAuth();
//     }

//     return () => {
//       isMounted = false;
//     };
//   }, [location.pathname]);

//   if (!authState.checked) {
//     return (
//       <div className="flex justify-center items-center h-screen">
//         <div className="w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
//       </div>
//     );
//   }

//   if (!authState.isAuthenticated) {
//     if (location.pathname !== "/login") {
//       return <Navigate to="/login" replace state={{ from: location }} />;
//     }
//     return null;
//   }

//   if (
//     requiredPermission &&
//     !authState.permissions.includes(requiredPermission)
//   ) {
//     return <Navigate to="/unauthorized" replace />;
//   }

//   return children;
// };

// export default ProtectedRoute;

import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getCurrentUser, clearAuthData, isAccessTokenExpired, refreshAccessToken } from './auth';

const ProtectedRoute = ({ children, requiredPermission }) => {
  const [authState, setAuthState] = useState({
    checked: false,
    isAuthenticated: false,
    user: null,
    permissions: [],
    roles: [],
  });
  const location = useLocation();

  useEffect(() => {
    let isMounted = true;
    let retryCount = 0;
    const maxRetries = 1;

    const checkAuth = async (attempt = 0) => {
      try {
        // Check if token needs refresh before making the request
        if (isAccessTokenExpired()) {
          const refreshSuccess = await refreshAccessToken();
          if (!refreshSuccess) {
            throw new Error('Token refresh failed');
          }
        }

        const user = await getCurrentUser(attempt > 0);
        if (!user && attempt < maxRetries) {
          // Try refreshing token once
          return await checkAuth(attempt + 1);
        }

        if (isMounted) {
          setAuthState({
            checked: true,
            isAuthenticated: !!user,
            user: user,
            permissions: user?.permissions || [],
            roles: user?.roles || [],
          });
        }
      } catch (error) {
        if (isMounted) {
          setAuthState({
            checked: true,
            isAuthenticated: false,
            user: null,
            permissions: [],
            roles: [],
          });
        }
      }
    };

    // Set up periodic token refresh check
    const checkInterval = setInterval(() => {
      if (isAccessTokenExpired()) {
        checkAuth();
      }
    }, 30000); // Check every 30 seconds

    if (
      !authState.checked ||
      (location.pathname !== '/login' && location.pathname !== '/dashboard/unauthorized')
    ) {
      checkAuth();
    }

    return () => {
      isMounted = false;
      clearInterval(checkInterval);
    };
  }, [location.pathname]);

  if (!authState.checked) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  if (!authState.isAuthenticated) {
    if (location.pathname !== '/login') {
      return <Navigate to="/login" replace state={{ from: location }} />;
    }
    return null;
  }

  if (requiredPermission && !authState.permissions.includes(requiredPermission)) {
    return <Navigate to="/dashboard/unauthorized" replace />;
  }

  return children;
};

export default ProtectedRoute;
